/* BVLLRVN theme JS — nav, cart drawer, product form, waitlist, popup, reveal. No service worker. */
(function () {
  'use strict';
  var d = document, root = d.documentElement;
  var BV = window.BV || { routes: { cart: '/cart', cartAdd: '/cart/add', cartChange: '/cart/change', root: '/' } };
  function $(s, c) { return (c || d).querySelector(s); }
  function $$(s, c) { return Array.prototype.slice.call((c || d).querySelectorAll(s)); }

  /* Old site registered /sw.js — unregister any leftover worker after the domain moves to Shopify. */
  if ('serviceWorker' in navigator && navigator.serviceWorker.getRegistrations) {
    navigator.serviceWorker.getRegistrations().then(function (rs) { rs.forEach(function (r) { r.unregister(); }); }).catch(function () {});
  }

  /* ---------- toast ---------- */
  function toast(msg, ms) {
    var t = $('#toast'); if (!t) return;
    t.textContent = msg; t.classList.add('show');
    clearTimeout(t._h); t._h = setTimeout(function () { t.classList.remove('show'); }, ms || 1800);
  }

  /* ---------- nav: collapse to hamburger whenever links would touch the wordmark ---------- */
  function navCheck() {
    var left = $('.nav-left'), logo = $('.site-nav .nav-logo');
    if (!left || !logo) return;
    root.classList.remove('nav-compact');
    var links = left.querySelectorAll('a'), last = links[links.length - 1];
    if (!last || last.offsetParent === null) return;
    if (last.getBoundingClientRect().right > logo.getBoundingClientRect().left - 32) root.classList.add('nav-compact');
  }
  window.addEventListener('resize', navCheck);
  window.addEventListener('load', navCheck);
  if (d.fonts && d.fonts.ready) d.fonts.ready.then(navCheck);
  navCheck();

  var mMenu = $('#mobileMenu'), toggle = $('#menuToggle');
  if (mMenu && toggle) {
    toggle.addEventListener('click', function () {
      mMenu.style.top = $('nav').getBoundingClientRect().bottom + 'px';
      var open = mMenu.classList.toggle('open');
      toggle.setAttribute('aria-expanded', open ? 'true' : 'false');
    });
    $$('a', mMenu).forEach(function (a) { a.addEventListener('click', function () { mMenu.classList.remove('open'); }); });
  }

  /* ---------- search overlay ---------- */
  var so = $('#searchOverlay');
  $$('[data-search-open]').forEach(function (b) {
    b.addEventListener('click', function () { if (!so) return; so.classList.add('open'); so.setAttribute('aria-hidden', 'false'); var i = $('input[type=search]', so); if (i) setTimeout(function () { i.focus(); }, 50); });
  });
  $$('[data-search-close]').forEach(function (b) { b.addEventListener('click', function () { so.classList.remove('open'); so.setAttribute('aria-hidden', 'true'); }); });

  /* ---------- cart drawer ---------- */
  var drawer = $('#drawer'), overlay = $('#overlay');
  function openCart() { if (!drawer) return false; drawer.classList.add('open'); overlay.classList.add('open'); drawer.setAttribute('aria-hidden', 'false'); return true; }
  function closeCart() { if (!drawer) return; drawer.classList.remove('open'); overlay.classList.remove('open'); drawer.setAttribute('aria-hidden', 'true'); }
  $$('[data-cart-open]').forEach(function (a) {
    a.addEventListener('click', function (e) {
      if (d.body.classList.contains('tpl-cart')) return; /* on /cart, just follow the link */
      if (openCart()) { e.preventDefault(); refreshCart(); }
    });
  });
  var cc = $('#cartClose'); if (cc) cc.addEventListener('click', closeCart);
  if (overlay) overlay.addEventListener('click', closeCart);

  function setCount(n) {
    $$('[data-cart-count]').forEach(function (el) { el.textContent = n > 0 ? n : ''; el.setAttribute('data-count', n); });
    var co = $('#drawerCheckout'); if (co) co.disabled = !(n > 0);
  }
  function refreshCart() {
    return fetch(BV.routes.root.replace(/\/$/, '') + '/?sections=cart-drawer-items', { credentials: 'same-origin' })
      .then(function (r) { return r.json(); })
      .then(function (data) {
        var html = data['cart-drawer-items']; if (!html) return;
        var tmp = d.createElement('div'); tmp.innerHTML = html;
        var frag = $('#cart-drawer-fragment', tmp); if (!frag) return;
        $('#drawerItems').innerHTML = frag.innerHTML;
        var tot = $('#cartTotal'); if (tot) tot.innerHTML = frag.getAttribute('data-total');
        setCount(parseInt(frag.getAttribute('data-count'), 10) || 0);
      }).catch(function () {});
  }
  d.addEventListener('click', function (e) {
    var b = e.target.closest('#drawerItems [data-key]');
    if (!b || b.tagName !== 'BUTTON') return;
    b.disabled = true;
    fetch(BV.routes.cartChange + '.js', {
      method: 'POST', credentials: 'same-origin',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ id: b.getAttribute('data-key'), quantity: parseInt(b.getAttribute('data-qty'), 10) })
    }).then(refreshCart).catch(function () { b.disabled = false; });
  });

  /* ---------- product form + variant picker ---------- */
  var ps = $('[data-product-section]');
  if (ps) {
    var json = $('[data-product-json]', ps), data = json ? JSON.parse(json.textContent) : { variants: [] };
    var form = $('[data-product-form]', ps), idInput = $('[data-variant-id]', ps), addBtn = $('[data-add]', ps), err = $('[data-error]', ps);
    var mainImg = $('[data-main-media] img', ps);
    function selected() { return $$('fieldset.opt', ps).map(function (fs) { var c = $('input:checked', fs); return c ? c.value : null; }); }
    function findVariant(opts) { return data.variants.filter(function (v) { return v.options.every(function (o, i) { return o === opts[i]; }); })[0]; }
    function swapImage(src) { if (mainImg && src) { mainImg.removeAttribute('srcset'); mainImg.src = src; } }
    function update() {
      var v = findVariant(selected());
      if (!v) { addBtn.disabled = true; addBtn.textContent = 'Unavailable'; return; }
      idInput.value = v.id;
      $('[data-price-current]', ps).innerHTML = v.price;
      var cmp = $('[data-price-compare]', ps); if (cmp) { cmp.innerHTML = v.compare || ''; cmp.style.display = v.compare ? '' : 'none'; }
      addBtn.disabled = !v.available; addBtn.textContent = v.available ? 'Add To Cart' : 'Sold Out';
      if (v.image) swapImage(v.image);
      if (history.replaceState) { var u = new URL(location.href); u.searchParams.set('variant', v.id); history.replaceState({}, '', u.toString()); }
    }
    $$('fieldset.opt input', ps).forEach(function (i) { i.addEventListener('change', update); });
    $$('.pdp-thumbs button', ps).forEach(function (b) {
      b.addEventListener('click', function () { $$('.pdp-thumbs button', ps).forEach(function (x) { x.classList.remove('sel'); }); b.classList.add('sel'); swapImage(b.getAttribute('data-media-src')); });
    });
    var mm = $('[data-main-media]', ps), lb = $('#lightbox');
    if (mm && lb) {
      mm.addEventListener('click', function () { var i = $('img', mm); if (!i) return; $('#lightboxImg').src = i.currentSrc || i.src; lb.classList.add('open'); });
      lb.addEventListener('click', function () { lb.classList.remove('open'); });
    }
    if (form) form.addEventListener('submit', function (e) {
      if (!window.fetch) return;
      e.preventDefault(); err.textContent = ''; addBtn.disabled = true;
      fetch(BV.routes.cartAdd + '.js', {
        method: 'POST', credentials: 'same-origin',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: JSON.stringify({ items: [{ id: parseInt(idInput.value, 10), quantity: 1 }] })
      }).then(function (r) { return r.json().then(function (j) { return { ok: r.ok, j: j }; }); })
        .then(function (res) {
          addBtn.disabled = false;
          if (!res.ok) { err.textContent = res.j.description || res.j.message || 'Could not add to cart.'; return; }
          refreshCart().then(function () { if (!openCart()) toast('Added to cart'); });
        }).catch(function () { addBtn.disabled = false; form.submit(); });
    });
  }

  /* ---------- waitlist (Shopify customer form, submitted in place) ---------- */
  var EMAIL_RE = /^[^\s@]+@[^\s@]+\.[^\s@]{2,}$/;
  var WL_OK = "You're on the list. Welcome to The Run.", WL_FAIL = "That didn't go through. Try again in a moment.";
  var IC_KEY = 'bv-ic-state';
  function icState() { try { return JSON.parse(localStorage.getItem(IC_KEY) || '{}'); } catch (e) { return {}; } }
  function icSet(s) { try { localStorage.setItem(IC_KEY, JSON.stringify(s)); } catch (e) {} }
  function assign(a, b) { for (var k in b) a[k] = b[k]; return a; }
  $$('form[data-waitlist]').forEach(function (f) {
    f.addEventListener('submit', function (e) {
      var st = $('[data-wl-status]', f), email = $('input[type=email]', f), trap = f.querySelector('input[name=website]');
      if (trap && trap.value) { e.preventDefault(); if (st) st.textContent = WL_OK; return; }
      if (!window.fetch || !window.FormData) return; /* native post */
      e.preventDefault();
      if (f.classList.contains('sending')) return;
      if (!EMAIL_RE.test(email.value.trim())) { st.textContent = "That email doesn't look right. Try again."; st.classList.add('err'); return; }
      f.classList.add('sending'); st.textContent = ''; st.classList.remove('err');
      var fd = new FormData(f); fd.delete('website');
      fetch(f.action, { method: 'POST', body: fd, credentials: 'same-origin' })
        .then(function (r) {
          f.classList.remove('sending');
          /* Shopify may ask for a captcha: fall back to a normal post so the shopper can complete it. */
          if (/challenge/.test(r.url)) { HTMLFormElement.prototype.submit.call(f); return; }
          if (!r.ok) throw new Error('bad');
          return r.text().then(function (html) {
            /* Read Shopify's answer: the re-rendered form carries its own status/errors. */
            var doc = new DOMParser().parseFromString(html, 'text/html');
            var back = f.id ? doc.getElementById(f.id) : null;
            var bst = back ? back.querySelector('[data-wl-status]') : null;
            if (bst && bst.classList.contains('err')) { st.textContent = bst.textContent.trim() || WL_FAIL; st.classList.add('err'); return; }
            icSet(assign(icState(), { joined: true }));
            st.textContent = WL_OK; f.reset();
            if (f.id === 'icpopForm') icHide(false);
            toast('Welcome to The Run', 2100);
          });
        })
        .catch(function () { f.classList.remove('sending'); st.textContent = WL_FAIL; st.classList.add('err'); });
    });
  });
  if (/customer_posted=true/.test(location.search)) icSet(assign(icState(), { joined: true }));

  /* ---------- The Run popup: once per visitor (14s / 40% scroll / exit intent); 7-day snooze ---------- */
  var icpop = $('#icpop'), icShown = false;
  function icEligible() { var s = icState(); if (s.joined) return false; if (s.dismissedAt && Date.now() - s.dismissedAt < 7 * 864e5) return false; return true; }
  function icShow() { if (!icpop || icShown || !icEligible()) return; icShown = true; icpop.classList.add('open'); }
  function icHide(dismiss) { if (!icpop) return; icpop.classList.remove('open'); if (dismiss) icSet(assign(icState(), { dismissedAt: Date.now() })); }
  if (icpop && icEligible() && !(window.Shopify && window.Shopify.designMode)) {
    var delay = (parseInt(icpop.getAttribute('data-delay'), 10) || 14) * 1000;
    setTimeout(icShow, delay);
    var icTick = false;
    var icScroll = function () {
      if (icTick) return; icTick = true;
      requestAnimationFrame(function () {
        icTick = false;
        if (icShown) { removeEventListener('scroll', icScroll); return; }
        if (scrollY > (d.body.scrollHeight - innerHeight) * 0.4) icShow();
      });
    };
    addEventListener('scroll', icScroll, { passive: true });
    d.addEventListener('mouseout', function (e) { if (!e.relatedTarget && e.clientY <= 0 && innerWidth > 980) icShow(); });
  }
  if (icpop) {
    $('#icpopClose').addEventListener('click', function () { icHide(true); });
    $('#icpopLater').addEventListener('click', function () { icHide(true); });
    icpop.addEventListener('click', function (e) { if (e.target === icpop) icHide(true); });
  }

  /* ---------- password page owner dialog ---------- */
  var owner = $('#pwOwner');
  if (owner && $('[data-owner-errors]', owner)) owner.classList.add('open');
  $$('[data-owner-open]').forEach(function (b) { b.addEventListener('click', function () { owner.classList.add('open'); var i = $('input[type=password]', owner); if (i) i.focus(); }); });
  $$('[data-owner-close]').forEach(function (b) { b.addEventListener('click', function () { owner.classList.remove('open'); }); });

  /* ---------- Journal: fill empty .divider with the bull mark ---------- */
  var tpl = $('#bullDivider');
  if (tpl) $$('.article-body .divider').forEach(function (el) { if (!el.children.length) el.innerHTML = tpl.innerHTML; });

  /* ---------- escape ---------- */
  d.addEventListener('keydown', function (e) {
    if (e.key !== 'Escape') return;
    var lb = $('#lightbox');
    if (lb && lb.classList.contains('open')) lb.classList.remove('open');
    else if (icpop && icpop.classList.contains('open')) icHide(true);
    else if (so && so.classList.contains('open')) so.classList.remove('open');
    else closeCart();
  });

  /* ---------- scroll reveal (visible-tab enhancement only) ---------- */
  if (location.search.indexOf('noanim') > -1) root.classList.add('no-anim');
  if (d.visibilityState === 'visible' && location.search.indexOf('noanim') < 0) root.classList.add('js-anim');
  // Same trigger as before (element top above 92% of viewport height, bottom below 0), via IntersectionObserver
  if ('IntersectionObserver' in window) {
    var revealIO = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) { if (e.isIntersecting) { e.target.classList.add('in'); revealIO.unobserve(e.target); } });
    }, { rootMargin: '0px 0px -8% 0px', threshold: 0 });
    $$('.reveal:not(.in)').forEach(function (el) { revealIO.observe(el); });
  } else {
    $$('.reveal').forEach(function (el) { el.classList.add('in'); });
  }
})();
